import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as saveAs from "file-saver";
import * as moment from 'moment';
import { ModalService } from 'app/services/modal.service';
import { AdminService } from 'app/services/admin.service';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { PageConfig } from 'config/page.config';
import { AddNewUserRequest, ApplicationData, ApplicationDataToJson, ChangeStatusEmailRequest, CheckForNegotiatorRequest, CommentData, NegotiatorResultData, RoleObject, SupplementalData, UpdateCaseRequest, UserData } from 'app/models/admin.model';
import { UserService } from 'app/users/user.service';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { PaymentInfoComponent } from '../common-sections/payment-info/payment-info/payment-info.component';
import { UploadFileDialogComponent } from '../common-sections/dialogs/upload-file-dialog/upload-file-dialog.component';
import { environment } from 'environments/environment';
import { FormService } from 'app/services/form.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { fieldPatterns } from 'app/utilities/form.utilities';
import { FormValidator } from 'app/ui-components/form/form-validators/form-validators';
import { stateDisplayNameAndApiName, StatesDisplayAndAPI } from 'app/utilities/states';
import { CountriesDisplayAndAPI, countryDisplayNameAndApiName } from 'app/utilities/countries';
import { UnlockCaseModel } from 'app/models/unlock-case.model';



@Component({
  selector: 'app-form-detail',
  templateUrl: './form-detail.component.html',
  styleUrls: ['./form-detail.component.scss', './form-detail.component2.scss']
})
export class FormDetailComponent implements OnInit {

  formType!: string;
  formName!: string;
  sourcePath: string = '';
  sourceName: string = '';
  sysId!: string;
  caseSysId!: string;
  caseNumber!: string;
  formTypeModal!: string;
  isFormLocked: boolean = false;

  user!: UserProfileRecord;
  userName!: string;
  userEmail!: string;
  userId!: string;
  orgId!: string;
  isOrgAdmin : boolean = false;
  isUsanAdmin : boolean = false;
  isNegotiator: boolean = false;
  isViewOnly: boolean = false;

  formTypeMap = { 
    'A': 'Single Entity Drug and Salt',
    'B': 'Single Entity' ,
    'C': 'Modified Salt Form' ,
    'D': 'USAN Revised Application' ,
    'E': 'Contact Lens Material' ,
    'F': 'Biologics' 
  };
  sourceMap = {
    'applicant-dashboard' : { path: '/usan/' + PageConfig.paths.usan.applicant, name: 'Applicant Dashboard'},
    'orgadmin-dashboard' : { path: '/usan/' + PageConfig.paths.usan.orgAdmin, name: 'Org Admin Dashboard'},
    'user-dashboard' : { path: '/usan/' + PageConfig.paths.usan.userDashboard, name: 'User Dashboard'},
    'admin-dashboard' : { path: '/usan/' + PageConfig.paths.usan.usanAdmin, name: 'Admin Dashboard'},
    'negotiator-dashboard' :  { path: '/usan/' + PageConfig.paths.usan.negotiator, name: 'Negotiator Dashboard'},
    'applicant-dashboard-viewOnly' : { path: '/usan/' + PageConfig.paths.usan.applicant, name: 'Applicant Dashboard'},
  }
  fileTypeMap = { 
    'docx': 'MS Word Document',
    'doc': 'MS Word Document',
    'pdf': 'PDF' ,
    'csv': 'Comma-separated values file' ,
    'xlsx': 'MS Excel Spreadsheet',
    'xls': 'MS Excel Spreadsheet',
    'jpg': 'Image File',
    'jpeg': 'Image File',
    'png': 'Image File',
    'cdx': 'ChemDraw File',
    'cdxml': 'ChemDraw File'
  };
  
  showResults : boolean = false;
  loadingComplete : boolean = false;
  data!: ApplicationData;
  isSmallView:boolean = false;
  paymentStatus!: string;

  latestComment!: string;
  commentsList!: CommentData[];
  newComments!: string;
  hasComments : boolean = false;
  @ViewChild('priorComments') commentsDialog!: TemplateRef<any>;
  priorCommentsDialogRef!: MatDialogRef<any, any>;

  supplDocList!: SupplementalData[];
  hasSupportDocs: boolean = false;

  usersList!: UserData[];
  negotiatorsList!: UserData[];
  applicantsList!: UserData[];
  showUsers: boolean = false;
  usersLoadingComplete: boolean = false;
  selectedUser!: any;
  showNegotiators: boolean = false;
  selectedCollaborator1!: any;
  selectedCollaborator2!: any;
  showCollab1: boolean = false;
  showCollab2: boolean = false;

  addNegotiatorDialogRef!: MatDialogRef<any, any>;
  @ViewChild('addNegotiator') addNegotiatorDialog!: TemplateRef<any>;
  negotiatorFirstName!: string;
  negotiatorLastName!: string;
  searchNegotiatorComplete: boolean = false;
  noNegotiatorsFound: boolean = false;
  negotiatorResults!: number;
  loadingNegotiators!: boolean;
  negotiatorDataList!: NegotiatorResultData[];
  negotiatorData!: NegotiatorResultData;
  showNegotiatorResults: boolean = false;
  selectedNegotiator!: NegotiatorResultData;
  negotiatorSelectionComplete: boolean = false;
  orgIDForNegotiator!: string;
  sameNegotiatorExistsAlready: boolean = false;
  allowCaseStatusUpdate : boolean = false;
  updateStatusListMap = {
    'Submitted' : [ 'In Review', 'Approved', 'Closed'],
    'In Review' : [ 'Approved', 'Closed'],
    'Approved' : [ 'Closed'],
    'Closed' : [ 'In Review', 'Approved']
  }
  selectedCaseStatus!: string;
  caseUpdateComplete: boolean = true;
  fileNumberEdit: boolean = false;
  selectedFileNumber!:string;
  fileNumberEditMod; boolean = false;
  selectedFileNumberMod!:string;

  accessToEdit: boolean = false;
  editFieldsForm!: FormGroup;
  @ViewChild('editSubstanceFields') editFieldsDialog!: TemplateRef<any>;
  editFieldsDialogRef!: MatDialogRef<any, any>;
  yesNoList = [ 'Yes', 'No'];
  needsUpdate: boolean = false;
  noChangeMessage!: string;
  initialFormValues: any;
  indicatorFields = ['bindToReceptor', 'innSubmission'];
  addntlExplnFields = ['bindToReceptorExplanation', 'innSubmissionExplanation'];
  caseStatusForEdit = ['submitted', 'in review', 'approved', 'closed'];
  editApplicantFieldsForm!: FormGroup;
  @ViewChild('editApplicantFields') editApplicantFieldsDialog!: TemplateRef<any>;
  editApplicantFieldsDialogRef!: MatDialogRef<any, any>;
  applicantAddress : any = {};
  states: StatesDisplayAndAPI[] = stateDisplayNameAndApiName;
  countries: CountriesDisplayAndAPI[] = countryDisplayNameAndApiName;
  displayStatesList: boolean = false;
  phoneTypes = [
    {value: 'Cell phone', key: 'cell'},
    {value: 'Landline', key: 'landline'}
  ];
  updateCaseTypes = [
    { id: '0', key: 'File Number'},
    { id: '1', key: 'File Number Modified'},
    { id: '2', key: 'Cash Receipt Number'},
  ]
  updateCaseType = {
    'fileNumber':  'File Number',
    'fileNumberMod': 'File Number Modified',
    'cashReceiptNumber' :'Cash Receipt Number',
    'paymentDate' : 'Payment Date',
    'finalAdoptedName' : 'Final Adopted Name',
    'finalAdoptedNameMod' : 'Final Adopted Name - Modified',
    'adoptedOrClosedDate' : 'Name Adopted or Closed Date',
  }
  cashReceiptNumberEdit: boolean = false;
  selectedCashReceiptNumber!:string;
  paymentDateSelected!: string;
  paymentReceivedDate !: string;
  finalAdoptedNameEdit: boolean = false;
  selectedFinalAdoptedName!: string;
  finalAdoptedNameModEdit: boolean = false;
  selectedFinalAdoptedNameMod!: string;
  adoptedOrClosedDateSelected!: string;
  adoptedOrClosedDate !: string;
  applicantName !: string;
  selectedApplicant !: UserData;
  allowEditApplicant : boolean = false;
  selectApplicantEdit : boolean = false;
  selectNewApplicant : boolean = false;
  companyName !: string;
  applicantExists : boolean = false;


  constructor( private route: ActivatedRoute,
    private router: Router,
    private responsive: BreakpointObserver,
    private dialog: MatDialog,
    private adminService: AdminService,
    private alertService: AlertsService,
    private userService: UserService,
    private modalService: ModalService,
    private formService: FormService,
    private formBuilder: FormBuilder
  ) {

  }

  ngOnInit(): void {
    
    let user = this.userService.profile;
    this.userName = user ? user.displayName : '';
    let orgId = user?.orgId;
    this.orgId = orgId ? orgId : '';
    this.user = user;    
    if(this.user.userRole === 'USAN Org Admin')
      this.isOrgAdmin = true;
    if(this.user.userRole === 'USAN AMA Admin')
      this.isUsanAdmin = true;
    if(this.user.userRole === 'USAN Negotiator')
      this.isNegotiator = true;
    this.retrieveApplication();
    this.determineViewMode();
    this.userEmail = this.user ? this.user.email : '';
    this.userId = this.user ? this.user.uniqueId : '';
    if(this.isOrgAdmin)
      this.retrieveUserDataForOrg();
    if(this.isUsanAdmin)
      this.retrieveUserData();
  }

  retrieveApplication() {
    this.fetchDetailsForRequest();
    let formTypeReq = 'Form' + this.formType;
    this.formTypeModal = formTypeReq;
    this.adminService.retrieveApplication(formTypeReq, this.caseSysId).subscribe({
          next: res => {
           //console.log('App response data '+ JSON.stringify(res.Data))
            if (res.Errors.length > 0) {
              this.alertService.displayError("Error occurred while retrieving data" + res.ErrorMessage);
            } else {  
              if(res.Data && res.Data.length > 0) { 
                this.data = this.fetchDetailsFromResponse(res.Data[0]);
                this.sysId = this.data.sysId ? this.data.sysId : '';
                this.caseNumber = this.data.caseNumber ? this.data.caseNumber : '';
                this.retrieveComments();
                this.retrieveSupplementalDocs();
                this.showResults = true;
                this.loadingComplete = true;
                this.paymentStatus = this.getPaymentStatus();
                this.checkAccessToEdit();
                this.paymentReceivedDate = this.retrieveFormattedDateForPicker(this.data.paymentReceivedDate ?? '');
                this.adoptedOrClosedDate = this.retrieveFormattedDateForPicker(this.data.adoptedOrClosedDate ?? '');
                this.isFormLocked = this.adminService.isApplicationLocked(this.data);
                this.applicantName = this.data.submittedBy ?? '';
                this.companyName = this.data.applicant ?? '';
              }
            }
          },
          error: error => {
            this.alertService.displayError("Error occurred while retrieving data" + error.message);
            this.loadingComplete = true;
          }  
        });
  }

  fetchDetailsForRequest() {
    let paramMap = this.route.snapshot.queryParamMap;
    let type = paramMap.get('formType');
    this.formType = type ? type : '';
    this.formName = this.formTypeMap[this.formType];
    let sourceStr;
    if(paramMap.get('source'))
      sourceStr = paramMap.get('source')
    this.sourcePath = this.sourceMap[sourceStr]?.path;
    this.sourceName = this.sourceMap[sourceStr]?.name; 
    let id = paramMap.get('id');
    this.caseSysId = id ? id : ''; 
    if(sourceStr && sourceStr.includes('applicant-dashboard-viewOnly'))
      this.isViewOnly = true;
    if(this.caseSysId && !this.isViewOnly)
      this.adminService.setCurrentApplicationCaseSysId(this.caseSysId);  
  }

  fetchDetailsFromResponse(data) :  ApplicationData { 
    let record : ApplicationData = {
      sysId : data.sys_id,
      caseNumber: data.caseNumber,
      lockedById: data.u_locked_by_sso_id,
      lastLockedTime: data.u_last_locked_activity_time,
      firstSuggestedName : data.u_suggested_names_in_order_of_preference_for_single_entity,
      revisionName : data.u_name_for_which_you_are_requesting_a_revision,
      revisionReason : data.u_reason_for_revision,
      designationForSalt : data.u_designation_for_salt_form,
      chemName : data.u_chemical_names_or_description,
      chemNameForEntity : data.u_chemical_names_or_description_for_single_entity,
      chemNameForSalt : data.u_chemical_names_or_description_for_salt_form,
      systematicName : data.u_systematic_names_or_description,
      molecularFormula : data.u_molecular_formula,
      molecularFormulaForEntity : data.u_molecular_formula_for_single_entity,
      molecularFormulaForSalt : data.u_molecular_formula_for_salt_form,
      molecularWeight : data.u_molecular_weight,
      molecularWeightForEntity : data.u_molecular_weight_for_single_entity,
      molecularWeightForSalt : data.u_molecular_weight_for_salt_form,
      isProdDrug : data.u_is_this_a_pro_drug,
      casRegistryNumber : data.u_chemical_abstracts_service_cas_registry_number,
      casRegistryForEntity : data.u_chemical_abstracts_service_cas_registry_number_for_single_entity,
      casRegistryForSalt : data.u_chemical_abstracts_service_cas_registry_number_for_salt_form,
      uniiNumber : data.u_unique_ingredient_identifier_unii_number,
      uniiNumberSalt : data.u_unique_ingredient_identifier_unii_number_salt,
      theraClaim : data.u_indications_therapeutic_claim,
      codeDesignation : data.u_code_designations,
      codeDesignationForEntity: data.u_code_designation_for_single_entity,
      codeDesignationForSalt: data.u_code_designation_for_salt_form,
      trademark: data.u_trademarks,
      trivialName: data.u_trivial_names,
      manufacturer: data.u_manufacturers,
      principalTheraUse: data.u_principal_theraputic_uses,
      pharmaAction: data.u_pharmacologic_action,
      bindToReceptor: data.u_does_the_substance_bind_to_a_receptor_enzyme_or_other_target,
      bindToReceptorExplanation: data.u_substance_bind_explanation,
      innSubmission: data.u_inn_submission,
      innSubmissionNumber: data.u_inn_submission_number,
      innSubmissionExplanation: data.u_inn_submission_explanation,
      clinicalTrialDate: data.u_phase_1_clinical_trials_began_date,

      isPolymerPresent : data.u_please_disclose_if_there_is_a_polymer_present,
      semiInterNetwork : data.u_please_disclose_whether_a_semi_interpenetrating_network_is_formed,
      degreeOfPolymerization : data.u_please_disclose_the_degreee_of_polymerization,
      monomerFormula : data.u_list_the_formula_for_each_monomer_and_for_the_whole_polymer,
      chemicalsAttached : data.u_chemicals_attached,
      manufacturingProcess : data.u_manufacturing_process,
      purity : data.u_purity_of_2_hydroxyethyl_methacrylate_if_applicable,
      waterContent : data.u_water_content,
      waterContentAtAmbientTemp : data.u_water_content_at_ambient_temperature_23_2_c,
      waterContentMeanValue : data.u_mean_value_standard_deviation_water_content,
      waterContentMeasurement : data.u_number_of_measurements_water_content,
      oxygenPermeability : data.u_oxygen_permeability,
      oxygenPermeability35 : data.u_oxygen_permeability_at_35_c,
      oxygenPermeabilityMeanValue : data.u_mean_value_standard_deviation_oxygen,
      oxygenPermeabilityMeasurement : data.u_number_of_measurements_oxygen,
      oxygenPermeabilityMethod : data.u_method_used_to_determine_oxygen_permeability,
      
      indApplNumber: data.u_ind_application_numbers,
      submittedBy: data.u_usan_applicant_firstname + ' ' + data.u_usan_applicant_lastname,
      submittedByUserObj : this.createApplicantObj(data),
      applicant: data.u_applicant,
      applicantEmail: data.u_usan_applicant_email,
      address: this.mergeAddress(data.u_street_1, data.u_street_2, data.u_city,
        data.u_state, data.u_postal_code, data.u_country),
      title: data.u_title,
      phone: data.u_telephone_number,
      phoneType: data.u_telephone_type,
      date: data.opened_at,
      contactPerson: data.u_primary_contact_first_name + ' '+ data.u_primary_contact_last_name,
      pronoun: data.u_pronoun,
      emailAddress: data.u_email_address,
      negotiator: data.negotiator?.name,
      caseStatus: data.u_case_status,
      usanUserName: this.mergeName(data.u_usan_user_firstname, data.u_usan_user_lastname),
      paymentStatus: data.u_payment_status,
      paymentType: data.u_payment_type,
      paymentDetails: data.u_trans_id,
      cashReceiptNumber: data.u_cash_receipt_number,
      paymentReceivedDate: data.u_payment_received_date,
      finalAdoptedName: data.u_final_adopted_name,
      adoptedOrClosedDate: data.u_name_adopted_or_closed_on,
      whoExplanation: data.u_who_explanation,
      finalAdoptedNameMod: data.u_final_adopted_name_modified,
      fileNumber: data.u_file_number_single_entity,
      fileNumberModified : data.u_file_number_modified,
      submittedDate : data.u_application_submitted_date,
      contactPersonFirstName: data.u_primary_contact_first_name,
      contactPersonLastName: data.u_primary_contact_last_name,
      collaborator1: this.mergeName(data.u_usan_collaborator_1_first_name, data.u_usan_collaborator_1_last_name),
      collaborator2: this.mergeName(data.u_usan_collaborator_2_first_name, data.u_usan_collaborator_2_last_name),
      previousApplicantName: data.u_previous_applicant_name ? data.u_previous_applicant_name : ''
    }
    return record;
  }

  createApplicantObj(data: any) : UserData {
    let userObj : UserData  = {
      firstName : data.u_usan_applicant_firstname,
      lastName : data.u_usan_applicant_lastname,
      email : data.u_usan_applicant_email,
      uniqueId : data.u_usan_applicant_sso_id,
      userName : data.u_usan_applicant_firstname + ' ' + data.u_usan_applicant_lastname
    }
    return userObj;
  }
  
  mergeAddress(line1: string, line2: string, city: string, state: string, zip: string, country: string) : string {
    let address = '';
    this.applicantAddress = {};
    let addrObj : any = {};
    if(line1) {
      address += ' ' + line1;
      addrObj['street1'] = line1;
    } if(line2) {
      address += ' ' + line2;
      addrObj['street2'] = line2;
    } if(city) {
      address += ' ' + city;
      addrObj['city'] = city;
    } if(state) {
      address += ' ' + state;
      addrObj['state'] = state;
    } if(zip) {
      address += ' ' + zip;  
      addrObj['zipCode'] = zip;
    } if(country) {
      address += ' ' + country;  
      addrObj['country'] = country;
    }
    Object.assign(this.applicantAddress, addrObj);
    return address;
  }

  mergeName(str1: string, str2: string): string {
    let returnStr = '';
    if(str1 && str1 != '')
      returnStr += str1;
    if(str2 && str2 != '')
      returnStr += ' ' + str2;
    return returnStr;
  }

  splitList(str: string) {
    let strList : string[] = [];
    if(str.includes(',')) 
      strList = str.split(',');
    else
      strList.push(str)
    return strList;
  }

  returnToSource() {
    this.router.navigate([this.sourcePath]);
  }

  printCopy() {
    window.print();
  }

  determineViewMode() {
    this.responsive.observe([Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait,
          Breakpoints.TabletPortrait, Breakpoints.TabletLandscape 
        ])
            .subscribe(result => {
              const breakpoints = result.breakpoints;
              this.isSmallView = false;
              if (breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape] ||
                breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]) {
                this.isSmallView = true;
              } 
            });
  }

  retrieveComments() {
    this.adminService.retrieveApplicationComments(this.sysId).subscribe({
      next: res => {
        if (res.Errors.length > 0) {
          this.alertService.displayError("Error occurred while retrieving comments" + res.ErrorMessage);
        } else {  
          if(res.Data && res.Data.result && res.Data.result.length > 0) { 
            this.processComments(res.Data.result);
            this.hasComments = true;
          }
        }
      },
      error: error => {
        this.alertService.displayError("Error occurred while retrieving comments" + error.message);
        this.loadingComplete = true;
      }  
    });
  }

  displayPriorComments() {
    this.priorCommentsDialogRef = this.dialog.open(this.commentsDialog, {
      width: '700px'
    });
  }

  cancel() {
    this.priorCommentsDialogRef.close();
  }

  saveComments() {
    let commentStr = this.newComments + ' - ' + this.userName;
    this.adminService.addApplicationComments(this.sysId, commentStr).subscribe({
      next: res => {
        if (res.Errors.length > 0) {
          this.alertService.displayError("Error occurred while adding comments" + res.ErrorMessage);
        } else {  
          if(res.Data && res.Data.result && res.Data.result.length > 0) { 
            this.processComments(res.Data.result);
            this.hasComments = true;
            this.newComments = '';
          }
        }
      },
      error: error => {
        this.alertService.displayError("Error occurred while adding comments" + error.message);
        this.loadingComplete = true;
      }  
    });
  }

  processComments(data: any) {
    let cList : CommentData[] = [];
    data.forEach( item => {
      let val : CommentData = {
        value : item.value,
        date : item.sys_created_on
      }
      cList.push(val);
    });
    cList.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    this.latestComment = cList[0].value + ' - ' +  new Date(cList[0].date).toLocaleDateString();
    this.commentsList = cList;
  }

  retrieveSupplementalDocs() {
    let formTypeReq = 'Form' + this.formType;
        this.adminService.retrieveApplicationAttachments(formTypeReq, this.caseSysId).subscribe({
          next: res => {
            //console.log('Suppl docs Response data '+ JSON.stringify(res.Data))
            if (res.Errors.length > 0) {
              this.alertService.displayError("Error occurred while retrieving supplemental data" + res.ErrorMessage);
            } else {  
              if(res.Data && res.Data.result) { 
                this.hasSupportDocs = true;
                let resp = res.Data.result;
                let suppList : SupplementalData[] = [];
                resp.forEach(item => {
                  let suppItem : SupplementalData = {
                    name: item.file_name,
                    id : item.sys_id,
                    fileType : this.fetchFileTypeOrExtn(item.file_name, true),
                    link : item.download_link,
                    type : this.fetchFileTypeOrExtn(item.file_name, false)
                  }
                  suppList.push(suppItem);
                });
                this.supplDocList = suppList;
              }
            }
          },
          error: error => {
            this.alertService.displayError("Error occurred while retrieving supplemental data" + error.message);
          }  
        });
  }

  fetchFileTypeOrExtn(name: string, isTypeCheck: boolean): string {
    let fType = '';
    if(name && name.includes('.')) {
      fType = name.substring(name.lastIndexOf('.')+ 1).toLowerCase();
      if(isTypeCheck)
        return this.fileTypeMap[fType] ? this.fileTypeMap[fType] : 'File';
      else {
        if(Object.keys(this.fileTypeMap).includes(fType))
          return fType;
        else
          return 'file';
      }
    }
    return 'file';
  }

  downloadDocument(item: SupplementalData) {
    if(item.id) {
      this.adminService.downloadAttachment(item.id).subscribe({
          next: res => {
            if(res) {
                saveAs(res, item.name);
            }
          },
          error: error => {
            this.alertService.displayError("Error occurred while downloading attachment" + error.message);
          }  
      }); 
     
    }
  }

  downloadAllDocuments() {
    if(this.supplDocList) {
      this.supplDocList.forEach(item =>
        this.downloadDocument(item));
    }
  }

  retrieveUserDataForOrg() {
    this.usersLoadingComplete = false;
    if(this.orgId) {
      const request = {
        'orgId': this.orgId
      }; 
      if(this.userEmail && this.userId) {
        this.adminService.getOrgAdminUsers(this.userEmail, this.userId, request).subscribe({
          next: res => {
            if (res.Errors.length > 0) {
              this.alertService.displayError("Error occurred while retrieving user data" + res.ErrorMessage);
            } else {  
              if(res.Data) {
                let results : UserData[] = [];
                let applicantUsers : UserData[] = [];
                res.Data.forEach(element => {
                  //let userType = this.parseUsanAccessType(element.role[0].roleName);
                  element.role.forEach(role => {
                    let userType = this.parseUsanAccessType(role.roleName);
                    let userStatus = element.userStatus;
                    let appRecord : UserData = {
                        userName: element.firstName + ' ' + element.lastName,
                        email: element.emailAddress,
                        uniqueId: element.ssouniqueId,
                        firstName: element.firstName,
                        lastName: element.lastName
                      };
                    if(userType === 'User' && userStatus === 'ACTIVE') {
                      results.push(appRecord);
                    } else if(userType === 'Applicant' && userStatus === 'ACTIVE') {
                      applicantUsers.push(appRecord);
                    }
                  });
                  
                });
                this.usersList = results;
                this.applicantsList = applicantUsers;
                this.usersLoadingComplete = true;
              }
            }
          },
          error: error => {
            this.alertService.displayError("Error occurred while retrieving user data" + error.message);
            this.usersLoadingComplete = true;
          }  
        }); 
      } else {
        console.log('No email and uniqueId found for the user');
        this.usersLoadingComplete = true;
      }
    } else {
      console.log('No org Id found for the user');
      this.usersLoadingComplete = true;
    }
  }

  parseUsanAccessType(str: string) : string {
    if(str && str.includes('USAN')) 
      return str.split('USAN ')[1];
    return str;
  } 

  
  openUserSelection(userType: string) {
    if(userType === 'user')
      this.showUsers = true;
    else if(userType === 'collab1')
      this.showCollab1 = true;
    else if(userType === 'collab2')
      this.showCollab2 = true;
  }

  addUserToApplication(userType: string) {
    if(userType === 'user') {
      if(this.selectedUser) 
        this.addUserOrCollaboratorToApplication(userType);
    } else if(userType === 'collab1') {
      if(this.selectedCollaborator1) {
        let newCollaborator = this.mergeName(this.selectedCollaborator1.firstName, this.selectedCollaborator1.lastName);
        let isAnotherCollaborator = this.data.collaborator2 && this.data.collaborator2 !== '' ? this.data.collaborator2 === newCollaborator : false;
        if(newCollaborator !== this.applicantName && !isAnotherCollaborator) 
          this.addUserOrCollaboratorToApplication(userType);
        else {
          this.alertService.displayError("Collaborator cannot be application submitter or another collaborator. Please choose another applicant.");
          this.selectedCollaborator1 = '';
        }
      }
    } else if(userType === 'collab2') {
      if(this.selectedCollaborator2) {
        let newCollaborator = this.mergeName(this.selectedCollaborator2.firstName, this.selectedCollaborator2.lastName);
        let isAnotherCollaborator = this.data.collaborator1 && this.data.collaborator1 !== '' ? this.data.collaborator1 === newCollaborator : false;
        if(newCollaborator !== this.applicantName && !isAnotherCollaborator)
          this.addUserOrCollaboratorToApplication(userType);
        else {
          this.alertService.displayError("Collaborator cannot be application submitter or another collaborator. Please choose another applicant.");
          this.selectedCollaborator2 = '';
        }
      }
    }
  }

  addUserOrCollaboratorToApplication(userType: string) {
    let request !: UpdateCaseRequest;
    if(userType === 'user') {
      request = {
        u_usan_user_email : this.selectedUser.email,
        u_usan_user_firstname : this.selectedUser.firstName,
        u_usan_user_lastname : this.selectedUser.lastName,
        u_usan_user_sso_id : this.selectedUser.uniqueId,
        caseSysId: this.caseSysId
      };
    } else if(userType === 'collab1') {
      request = {
        u_usan_collaborator_1_email : this.selectedCollaborator1.email,
        u_usan_collaborator_1_first_name : this.selectedCollaborator1.firstName,
        u_usan_collaborator_1_last_name : this.selectedCollaborator1.lastName,
        u_usan_collaborator_1_sso_id : this.selectedCollaborator1.uniqueId,
        caseSysId: this.caseSysId
      };
    } else if(userType === 'collab2') {
      request = {
        u_usan_collaborator_2_email : this.selectedCollaborator2.email,
        u_usan_collaborator_2_first_name : this.selectedCollaborator2.firstName,
        u_usan_collaborator_2_last_name : this.selectedCollaborator2.lastName,
        u_usan_collaborator_2_sso_id : this.selectedCollaborator2.uniqueId,
        caseSysId: this.caseSysId
      };
    }
    this.adminService.updateCaseRequest(this.formTypeModal, this.sysId, request).subscribe({
        next: res => {
         // console.log('Response data '+ JSON.stringify(res.Data))
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while assigning " + userType + " to application" + res.ErrorMessage);
          } else {  
            if(res.Data && res.Data.result) {
              if(userType === 'user') {
                this.data.usanUserName = this.mergeName(res.Data.result.u_usan_user_firstname, res.Data.result.u_usan_user_lastname);
                this.alertService.displaySuccess("User has been assigned to the application successfully");
                this.selectedUser = '';
                this.showUsers = false;
              } else if(userType === 'collab1') {
                this.data.collaborator1 = this.mergeName(res.Data.result.u_usan_collaborator_1_first_name, res.Data.result.u_usan_collaborator_1_last_name);
                this.alertService.displaySuccess("Collaborator 1 has been assigned to the application successfully");
                this.selectedCollaborator1 = '';
                this.showCollab1 = false;
              } else if(userType === 'collab2') {
                this.data.collaborator2 = this.mergeName(res.Data.result.u_usan_collaborator_2_first_name, res.Data.result.u_usan_collaborator_2_last_name);
                this.alertService.displaySuccess("Collaborator 2 has been assigned to the application successfully");
                this.selectedCollaborator2 = '';
                this.showCollab2 = false;
              }
            }
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while assigning user to application" + error.message);
        }  
      }); 
  }

  cancelUserSelection(userType: string) {
    if(userType === 'user')
      this.showUsers = false;
    else if(userType === 'collab1')
      this.showCollab1 = false;
    else if(userType === 'collab2')
      this.showCollab2 = false;
  }

  openNegotiatorSelection() {
    if(this.isUsanAdmin) {
    this.addNegotiatorDialogRef = this.dialog.open(this.addNegotiatorDialog, {
      width: '700px'
    });
    this.loadingNegotiators = false;
    this.sameNegotiatorExistsAlready = false;
    }
  }

  searchForNegotiator() {
    this.searchNegotiatorComplete = false;
    this.noNegotiatorsFound = false;
    this.showNegotiatorResults = false;
    this.loadingNegotiators = true;
    this.sameNegotiatorExistsAlready = false;
    //check if the same negotiator is already assigned
    let currentNegotiator = this.data.negotiator;
    let negotiatorToSearch = this.negotiatorFirstName + ' ' + this.negotiatorLastName;
    if(!currentNegotiator || currentNegotiator.toLowerCase() != negotiatorToSearch.toLowerCase()) {
      this.adminService.searchNegotiator(this.negotiatorFirstName, this.negotiatorLastName).subscribe({
        next: res => {
         // console.log('Response data '+ JSON.stringify(res.Data))
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while retrieving negotiator" + res.ErrorMessage);
          } else {  
            if(res.Data && res.Data.result && res.Data.result.length > 0) {
              this.negotiatorDataList = res.Data.result;
              this.showNegotiatorResults = true;
            } else {
              this.noNegotiatorsFound = true;
            }
            this.loadingNegotiators = false;
            this.searchNegotiatorComplete = true;
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while retrieving negotiator" + error.message);
        }  
      });
    } else {
      console.log('Same Negotiator already exists');
      this.sameNegotiatorExistsAlready = true;
      this.searchNegotiatorComplete = true;
      this.loadingNegotiators = false;
    }
  }

  disableSearchBtn() {
    if(!this.negotiatorFirstName || !this.negotiatorLastName)
      return true;
    if(this.searchNegotiatorComplete)
      return true;
    return false;
  }

  selectingNegotiator(negotiator: any) {
    this.selectedNegotiator = negotiator;
    this.negotiatorSelectionComplete = true;
  }

  assignNegotiator() {
    if(this.selectedNegotiator) {
      let request = {
        'caseSysId' : this.caseSysId,
        'u_negotiator' : this.selectedNegotiator.sys_id
      }
      this.orgIDForNegotiator = environment.orgIdForNegotiators;
      this.adminService.updateCaseRequest(this.formTypeModal, this.sysId, request).subscribe({
        next: res => {
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while assigning negotiator to application" + res.ErrorMessage);
          } else {  
            if(res.Data && res.Data.result) {
              this.data.negotiator = res.Data.result.negotiator?.name;
              this.postAssignNegotiator();
            }
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while assigning negotiator to application" + error.message);
        }  
      });
    }
  }

  postAssignNegotiator() {
    if(this.selectedNegotiator && this.selectedNegotiator.email) {
      //check if the user is a negotiator in OM already
      let request : CheckForNegotiatorRequest = {
        email : this.selectedNegotiator.email,
        orgId : this.orgIDForNegotiator
      }
      this.adminService.checkForUSANNegotiator(request).subscribe({
        next: res => {
          if(res.Data) {
            //No need to add in OM, the user is already a negotiator
            this.alertService.displaySuccess("Negotiator has been assigned successfully");
            this.cancelNegotiatorSearch(); 
          } else {
            console.log('Negotiator check returned null or false. About to add in OM')
            this.addNewNegotiatorInOM();
          }
        },
        error: error => {
          let respError = error?.error?.ErrorMessage; 
          this.alertService.displayError("Error occurred " + error.message);
        }  
      }); 
    }
  }

  addNewNegotiatorInOM() {
    let roleName : RoleObject = {
      roleName : 'USAN Negotiator'
    }
    let request : AddNewUserRequest = {
      firstName : this.negotiatorFirstName,
      lastName : this.negotiatorLastName,
      emailAddress : this.selectedNegotiator.email,
      role : [roleName]
    }
    this.adminService.addNewUser(this.orgIDForNegotiator, request, this.userEmail, this.userId).subscribe({
      next: res => {
        if (res.ErrorMessage) {
          this.alertService.displayError("Error occurred while adding negotiator to Org Manager" + res.ErrorMessage);

        } else {  
          this.alertService.displaySuccess("Negotiator has been assigned and added successfully");
          this.cancelNegotiatorSearch(); 
        }
      },
      error: error => {
        let respError = error?.error?.ErrorMessage; 
        this.alertService.displayError("Error occurred while adding negotiator to Org Manager " + error.message);
      }  
    }); 
  }

  resetNegotiatorSelection() {
    this.showNegotiators = false;
    this.noNegotiatorsFound = false;
    this.negotiatorFirstName = '';
    this.negotiatorLastName = '';
    this.searchNegotiatorComplete = false;
    if(this.selectedNegotiator)
      Object.assign(this.selectedNegotiator, {});
    this.negotiatorSelectionComplete = false;
  }

  cancelNegotiatorSearch() {
    this.resetNegotiatorSelection();
    this.addNegotiatorDialogRef.close();
  }


  disableUpdateButton() {
    if( !this.selectedUser)
      return true;
    if(this.isOrgAdmin && this.selectedUser.userName === this.data.usanUserName)
      return true;
    if(this.isUsanAdmin && this.selectedUser.userName === this.data.negotiator)
      return true;
    return false;
  }

  private getPaymentStatus(): string {
    if (!this.data.paymentStatus) {
      return 'Pending';
    } else if (!!this.data.paymentStatus && this.data.paymentStatus.length === 0) {
      return 'Pending';
    } else if (!!this.data.paymentStatus && this.data.paymentStatus === 'PaymentComplete') {
      return 'Completed';
    }

    return this.data.paymentStatus;
  }

  openPaymentModal () {
    let data = {
      formType: this.formTypeModal,
      sysIdVar: this.sysId,
      caseSysIdVar: this.caseSysId,
      caseNumber: this.caseNumber
    };

      const dialogRef = this.dialog.open(PaymentInfoComponent, {
        width: this.modalService.getAppropriateWidthProperty(650),
        maxWidth: this.modalService.getAppropriateMaxWidthProperty(),
        autoFocus: false,
         data: data
      });
     
      dialogRef.afterClosed().subscribe(result => {
        setTimeout(() => {
          if(this.formService.isPaymentCompleted()) {
            this.retrieveApplication();
          }
        }, 1000);
      });
   
  }

  uploadDocument() {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
      data: { 
        formType: this.formTypeModal, 
        sysId: this.sysId,
        caseSysId : this.caseSysId
      }
    });
    dialogRef.afterClosed().subscribe( data => {
      if(data) {
        setTimeout(() => {
          this.retrieveSupplementalDocs();
        }, 1000);
      }
    }); 
  }

  openStatusSelection() {
    this.allowCaseStatusUpdate = true;
  }

  updateCaseStatus() {
    if(this.selectedCaseStatus) {
      this.caseUpdateComplete = false;
      let request : UpdateCaseRequest = {
        u_case_status : this.selectedCaseStatus,
        caseSysId : this.caseSysId
      }
      this.adminService.updateCaseRequest(this.formTypeModal, this.sysId, request).subscribe({
        next: res => {
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while updating case status" + res.ErrorMessage);
          } else {  
            if(res.Data && res.Data.result) {
              this.data.caseStatus = res.Data.result.u_case_status;
              this.sendEmailNotification();
            }
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while updating case status" + error.message);
        }  
      });
    }
  }

  sendEmailNotification() {
    let request : ChangeStatusEmailRequest = {
      applicantEmail: this.data.applicantEmail,
      applicantName: this.data.applicant,
      status: this.data.caseStatus,
      fileNumber: this.data.fileNumber
    }
    this.adminService.sendChangeStatusEmailNotification(request).subscribe({
        next: res => {
          if(res.Data && res.Data === 'SUCCESS') {
            this.alertService.displaySuccess("Case status has been updated successfully");
            this.selectedCaseStatus = '';
            this.allowCaseStatusUpdate = false;
            this.caseUpdateComplete = true;
          } else {
            this.alertService.displayError("Error occurred while sending case status email notification" + res.ErrorMessage);
            this.caseUpdateComplete = true;
          } 
        },
        error: error => {
          this.alertService.displayError("Error occurred while sending case status email" + error.message);
          this.caseUpdateComplete = true;
        }  
    });
  }

  cancelStatusSelection () {
    this.allowCaseStatusUpdate = false;
  }

  enableCaseEdit(idx: string) {
    if(idx === 'fileNumber') {
      this.fileNumberEdit = true;
      this.selectedFileNumber = this.data.fileNumber;
    } else if(idx === 'fileNumberMod') {
      this.fileNumberEditMod = true;
      this.selectedFileNumberMod = this.data.fileNumberModified;
    } else if(idx === 'cashReceiptNumber') {
      this.cashReceiptNumberEdit = true;
    } else if(idx === 'finalAdoptedName') {
      this.finalAdoptedNameEdit = true;
    } else if(idx === 'finalAdoptedNameMod') {
      this.finalAdoptedNameModEdit = true;
    }
  }

  
  updateCase(field: string) {
    let request : any;
    let requestSet: boolean = false; 
    
    if(field === 'fileNumber' && this.selectedFileNumber) {
      request = {
          u_file_number_single_entity : this.selectedFileNumber,
          caseSysId : this.caseSysId
      }
      requestSet = true; 
    } else if(field === 'fileNumberMod' && this.selectedFileNumberMod) {
      request = {
          u_file_number_modified : this.selectedFileNumberMod,
          caseSysId : this.caseSysId
      }
      requestSet = true;
    } else if(field === 'cashReceiptNumber' && this.selectedCashReceiptNumber) {
      request = {
          u_cash_receipt_number : this.selectedCashReceiptNumber,
          caseSysId : this.caseSysId
      }
      requestSet = true;  
    } else if(field === 'paymentDate' && this.paymentDateSelected) {
      request = {
          u_payment_received_date : this.paymentDateSelected,
          caseSysId : this.caseSysId
      }
      requestSet = true;  
    } else if(field === 'finalAdoptedName' && this.selectedFinalAdoptedName) {
      request = {
          u_final_adopted_name : this.selectedFinalAdoptedName,
          caseSysId : this.caseSysId
      }
      requestSet = true;  
    } else if(field === 'finalAdoptedNameMod' && this.selectedFinalAdoptedNameMod) {
      request = {
          u_final_adopted_name_modified : this.selectedFinalAdoptedNameMod,
          caseSysId : this.caseSysId
      }
      requestSet = true;  
    } else if(field === 'adoptedOrClosedDate' && this.adoptedOrClosedDateSelected) {
      request = {
          u_name_adopted_or_closed_on : this.adoptedOrClosedDateSelected,
          caseSysId : this.caseSysId
      }
      requestSet = true;  
    }
    if(requestSet) {
      this.adminService.updateCaseRequest(this.formTypeModal, this.sysId, request).subscribe({
        next: res => {
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while updating " + this.updateCaseType[field] + res.ErrorMessage);
          } else {  
            if(res.Data && res.Data.result) {
              if(field === 'fileNumber') {
                this.data.fileNumber = res.Data.result.u_file_number_single_entity;
                this.selectedFileNumber = '';
                this.fileNumberEdit = false;
              } else if(field === 'fileNumberMod') {
                this.data.fileNumberModified = res.Data.result.u_file_number_modified;
                this.selectedFileNumberMod = '';
                this.fileNumberEditMod = false;
              } else if(field === 'cashReceiptNumber') {
                this.data.cashReceiptNumber = res.Data.result.u_cash_receipt_number;
                this.cashReceiptNumberEdit = false;
              } else if(field === 'paymentDate') {
                this.data.paymentReceivedDate = res.Data.result.u_payment_received_date;
              } else if(field === 'finalAdoptedName') {
                this.data.finalAdoptedName = res.Data.result.u_final_adopted_name;
                this.finalAdoptedNameEdit = false;
              } else if(field === 'finalAdoptedNameMod') {
                this.data.finalAdoptedNameMod = res.Data.result.u_final_adopted_name_modified;
                this.finalAdoptedNameModEdit = false;
              } else if(field === 'adoptedOrClosedDate') {
                this.data.adoptedOrClosedDate = res.Data.result.u_name_adopted_or_closed_on;
              }
              this.alertService.displaySuccess(this.updateCaseType[field]+" has been updated successfully");
              
            }
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while updating " + this.updateCaseType[field] + error.message);
        }  
      }); 
    }
  }

  disableEditFileNumber(idx: string) {
    if(idx === 'fileNumber') {
      if(!this.selectedFileNumber)   
        return true;
      if(this.selectedFileNumber && !this.selectedFileNumber.match(new RegExp(/^[a-zA-Z0-9\-]*$/)))
        return true;
      return false;
    } else {
      if(!this.selectedFileNumberMod)   
          return true;
      if(this.selectedFileNumberMod && !this.selectedFileNumberMod.match(new RegExp(/^[a-zA-Z0-9\-]*$/)))
          return true;
      return false;
    }
  }

  cancelCaseFieldSelection(idx: string) {
    if(idx === 'fileNumber')
      this.fileNumberEdit = false;
    else if(idx === 'fileNumberMod') 
      this.fileNumberEditMod = false;
    else if(idx === 'cashReceiptNumber')
      this.cashReceiptNumberEdit = false;
  }

  cancelCashReceiptNumberEdit() {
    this.cashReceiptNumberEdit = false;
  }

  disableCashReceiptNumberEdit() {
    if(!this.cashReceiptNumberEdit)
      return true;

    return false;
  }

  checkAccessToEdit() {
    if(this.isNegotiator ||  this.isUsanAdmin) {
      if(this.data.caseStatus && this.caseStatusForEdit.includes(this.data.caseStatus.toLowerCase()))
        this.accessToEdit = true;
    } else if(this.isOrgAdmin) {
        if(this.data.caseStatus && this.data.caseStatus.toLowerCase() === 'draft')
          this.accessToEdit = true;
    }
  }

  displayEditFields() {
    const buttonElt = document.activeElement as HTMLElement;
    buttonElt?.blur();
    this.editFieldsDialogRef = this.dialog.open(this.editFieldsDialog, {
      width: '900px'
    });
    this.initializeEditFields(this.data);
    this.noChangeMessage = '';
  }

  initializeEditFields(data: ApplicationData) {
    this.editFieldsForm = this.formBuilder.group({
      firstSuggestedName : [ data.firstSuggestedName, 
        ('A,B,C,E,F').includes(this.formType) ? [Validators.required,this.validMultiSuggestedNameCountCheck()] :''],
      revisionName : [ data.revisionName, this.singleSuggestedName()],
      systematicName : [ data.systematicName, this.isRequiredForForm('F')],
      revisionReason : [data.revisionReason, ''],
      designationForSalt : [ data.designationForSalt, this.isRequiredForForm('A')], 
      chemName : [ data.chemName, this.isRequiredForForm('B,C,D,E')],
      chemNameForEntity : [ data.chemNameForEntity, this.isRequiredForForm('A')],
      chemNameForSalt : [ data.chemNameForSalt, this.isRequiredForForm('A')],
      molecularFormula : [ data.molecularFormula, 
        ('B,C,D,F').includes(this.formType)?[Validators.required, Validators.pattern(fieldPatterns.molecularFormula),FormValidator.validParenthesis()] : ''],  
      molecularFormulaForEntity : [ data.molecularFormulaForEntity, 
        this.formType ==='A'?[Validators.required, Validators.pattern(fieldPatterns.molecularFormula),FormValidator.validParenthesis()] : ''],
      molecularFormulaForSalt : [ data.molecularFormulaForSalt, 
         this.formType ==='A'?[Validators.required, Validators.pattern(fieldPatterns.molecularFormula),FormValidator.validParenthesis()] : ''], 
      molecularWeight : [ data.molecularWeight, 
        ('B,C,D,F').includes(this.formType)?[Validators.required, Validators.pattern(fieldPatterns.molecularFormula)] : ''],
      molecularWeightForEntity : [ data.molecularWeightForEntity, 
        this.formType ==='A'?[Validators.required, Validators.pattern(fieldPatterns.molecularFormula)] : ''],
      molecularWeightForSalt : [ data.molecularWeightForSalt, 
        this.formType ==='A'?[Validators.required, Validators.pattern(fieldPatterns.molecularFormula)] : ''], 
      isProdDrug : [ data.isProdDrug, ''], 
      casRegistryNumber : [ data.casRegistryNumber, 
        ('B,C,D,E,F').includes(this.formType)?[Validators.required, Validators.pattern(fieldPatterns.molecularFormula)] : ''],
      casRegistryForEntity : [ data.casRegistryForEntity, 
        this.formType ==='A'?[Validators.required, Validators.pattern(fieldPatterns.molecularFormula)] : ''],
      casRegistryForSalt : [ data.casRegistryForSalt, 
        this.formType ==='A'?[Validators.required, Validators.pattern(fieldPatterns.molecularFormula)] : ''],
      theraClaim : [ data.theraClaim, ''],
      uniiNumber : [ data.uniiNumber, [Validators.pattern(/^(not\savailable)|(n\/a)|(n\\a)|(unknown)|[a-zA-Z0-9]+$/i)]],
      codeDesignation : [ data.codeDesignation, this.isRequiredForForm('B,C,D,F')],
      codeDesignationForEntity: [ data.codeDesignationForEntity, this.isRequiredForForm('A')],
      codeDesignationForSalt: [ data.codeDesignationForSalt, this.isRequiredForForm('A')],
      trademark: [ data.trademark, Validators.required],
      trivialName: [ data.trivialName, ''],
      manufacturer: [ data.manufacturer, Validators.required],
      principalTheraUse: [ data.principalTheraUse, this.isRequiredForForm('A,B,C,F')],
      pharmaAction: [ data.pharmaAction, this.isRequiredForForm('A,B,F')],
      bindToReceptor: [ data.bindToReceptor, this.isRequiredForForm('A,B,F')],
      bindToReceptorExplanation: [ data.bindToReceptorExplanation, ''],
      innSubmission: [ data.innSubmission, this.isRequiredForForm('A,B,F')],
      innSubmissionNumber: [ data.innSubmissionNumber, ''],
      innSubmissionExplanation: [ data.innSubmissionExplanation, ''], 
      clinicalTrialDate: [ data.clinicalTrialDate ? new Date(data.clinicalTrialDate).toLocaleDateString('en-US', 
        {timeZone: 'UTC',year: 'numeric',month: '2-digit',day: '2-digit'}) : '', [Validators.required, this.isDateValid]], 
      indApplNumber: [ data.indApplNumber, this.isRequiredForForm('A,B,C,D,F')],
      isPolymerPresent : [ data.isPolymerPresent, ''],
      semiInterNetwork : [ data.semiInterNetwork, ''],
      degreeOfPolymerization : [ data.degreeOfPolymerization, ''],
      monomerFormula : [ data.monomerFormula, ''], 
      chemicalsAttached : [ data.chemicalsAttached, ''],
      manufacturingProcess : [ data.manufacturingProcess, ''],
      purity : [ data.purity, ''],
      waterContent : [ data.waterContent, ''],
      waterContentAtAmbientTemp : [ data.waterContentAtAmbientTemp, ''],
      waterContentMeanValue : [ data.waterContentMeanValue, [Validators.pattern(/^\d*\.\d+$|^\d+$/)]],
      waterContentMeasurement : [ data.waterContentMeasurement, [Validators.pattern(/^\d*$/)]],
      oxygenPermeability : [ data.oxygenPermeability, ''],
      oxygenPermeability35 : [ data.oxygenPermeability35, ''],
      oxygenPermeabilityMeanValue : [ data.oxygenPermeabilityMeanValue, [Validators.pattern(/^\d*\.\d+$|^\d+$/)]],
      oxygenPermeabilityMeasurement : [ data.oxygenPermeabilityMeasurement, [Validators.pattern(/^\d*$/)]],
      oxygenPermeabilityMethod : [ data.oxygenPermeabilityMethod, ''] 
    }, { validators: this.isInSubmissionRequired});
    this.initialFormValues = Object.assign({}, this.editFieldsForm.value);
  }

  isRequiredForForm(form: string): ValidatorFn | null {
    if(form.includes(this.formType)) {
      return Validators.required;
    } else
    return null;
  }
  
  validMultiSuggestedNameCountCheck(): ValidatorFn | null {
      return (control: AbstractControl): ValidationErrors | null => {
        if(!control.value) {
          return null;
        }
        const val: string = control.value;
        if('A,B,E,F'.includes(this.formType)) { 
          if(val.includes(',')) {
            let namesArray = val.split(',');
            let len = namesArray.length;
            if(len > 10)
              return { invalidNumberOfSuggestedNames: true };
            return namesArray.every(name => name != '') ? null : { invalidSuggestedNames: true };
          }
        } else if(this.formType ==='C') {  
            if(val.includes(','))
              return { invalidNumberOfSuggestedNames: true };
            return null;
        }
      
        return null;
      }
  }
  
  singleSuggestedName() : ValidatorFn | null {
    return (control: AbstractControl): ValidationErrors | null => {
      if(!control.value) {
        return null;
      }
      const val: string = control.value;
      if(val.includes(','))
        return { invalidNumberOfSuggestedNames: true };
      return null;
    }
  }

  isDateValid: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const val = !control.value? true :moment(control.value, 'MM/DD/YYYY', true).isValid();
    return val? null : { dateInvalid: true };
  
  }

  isBindReceptorExplanationRequired: ValidatorFn = (control: AbstractControl):  ValidationErrors | null =>{
    if(control.touched && this.substBindToReceptor() && this.substBindToReceptor() === 'Yes')
      return Validators.required;
    return null;
  }

  isInSubmissionRequired: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>{ 
    const innSubmissionFld = control.get('innSubmission');
    const innSubmissionNumberFld = control.get('innSubmissionNumber');
    if(innSubmissionFld && innSubmissionFld.value === 'Yes' && ('A,B,F').includes(this.formType)) {
      if(innSubmissionNumberFld?.value === '')
        setTimeout(() => innSubmissionNumberFld?.setErrors({'invalidValue': true}) );
    }
    return null;
  }

  disableSaveBtn() {
    if(!this.editFieldsForm?.valid) 
      return true; 
    if(!this.editFieldsForm?.touched && this.editFieldsForm?.pristine) 
        return true; 
    return false; 
  }
  

  get substBindToReceptor() {
    return this.editFieldsForm.get('bindToReceptor')?.value;
  }

  get innSubmissionValue() {
    return this.editFieldsForm.get('innSubmission')?.value;
  }

  saveEditSubstanceFields() {
    this.saveEditFields(this.editFieldsForm);
  }

  saveEditFields(formGroup: FormGroup) {
    this.needsUpdate = false;
    this.noChangeMessage = '';
    let updatedFields :any = {};  
    this.findUpdatedFields(formGroup, updatedFields)
    if(this.needsUpdate){
      updatedFields['caseSysId']  = this.caseSysId;
      let requestBody:Partial<UpdateCaseRequest> = {};
      Object.assign (requestBody, updatedFields); 
      this.adminService.updateCaseRequest(this.formTypeModal, this.sysId, requestBody).subscribe({
        next: res => {
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while updating application field(s)" + res.ErrorMessage);
          } else {  
            if(res.Data && res.Data.result) {
              this.data = this.fetchDetailsFromResponse(res.Data.result);
              if(formGroup === this.editFieldsForm)
                this.editFieldsDialogRef.close();
              else {
                //this.editApplicantFieldsDialogRef.close();
                this.applicantName = this.data.submittedBy ?? '';
                this.cancelEditApplicantFields();
              }
              this.alertService.displaySuccess("Application has been updated successfully");
            }
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while updating application field(s)" + error.message);
        }  
      }); 
    } else {
      if(this.applicantExists)
        this.noChangeMessage = 'Applicant cannot be collaborator';
      else 
        this.noChangeMessage = 'No changes found';
    }
  }

  findUpdatedFields(formGroup : FormGroup, updatedFields:any) {
    this.needsUpdate = false;
    Object.keys(formGroup.controls).forEach(key => {
      let formElement = formGroup.controls[key];
      let val = formElement.value;
      if(formElement.touched && !formElement.pristine) {
        if(this.initialFormValues[key] != val) { 
          const field = ApplicationDataToJson[key];
          if(formGroup === this.editFieldsForm) {
            if(this.addntlExplnFields.includes(key)) {
              //capture the explanation only if the indicator field is yes.
              const ind = key.substring(0, key.indexOf('Explanation'))
              const indFieldVal = formGroup.controls[ind]?.value;
              if(indFieldVal === 'Yes') {
                updatedFields[field]= val;
                this.needsUpdate = true;
              }
            } else {
              if(this.indicatorFields.includes(key)) {
                if(val === 'No') {//clear explanantion field if indicator is swtiched to No
                  updatedFields[ApplicationDataToJson[key+'Explanation']]= '';
                  if(key === 'innSubmission') //also clear innSubmissionNumber as well
                    updatedFields[ApplicationDataToJson[key+'Number']]= '';
                }
              }
              updatedFields[field]= val;
              this.needsUpdate = true;
            } 
          } else {
            updatedFields[field]= val;
            this.needsUpdate = true;
          }
        }
      }
      if(key === 'applicant' && this.selectNewApplicant) { 
        if(this.data.submittedBy !== val.userName) {
          let isSameAsCollaborator1 = this.data.collaborator1 && this.data.collaborator1 !== '' ? this.data.collaborator1 === val.userName : false;
          let isSameAsCollaborator2 = this.data.collaborator2 && this.data.collaborator2 !== '' ? this.data.collaborator2 === val.userName : false;
          if(!isSameAsCollaborator1 && !isSameAsCollaborator2) {
            updatedFields['u_usan_applicant_email'] = val.email;
            updatedFields['u_usan_applicant_sso_id'] = val.uniqueId;
            updatedFields['u_usan_applicant_firstname'] = val.firstName;
            updatedFields['u_usan_applicant_lastname'] = val.lastName;
            updatedFields['u_previous_applicant_name'] = this.data.submittedBy;
            this.needsUpdate = true;
          } else {
            this.applicantExists = true;
          }
        } else {
          this.needsUpdate = false;
        }
      }
    });
  }

  cancelEditFields () {
    this.editFieldsDialogRef.close();
  }

  public isAmaAdminOrNegotiator(): boolean {
    return (this.isUsanAdmin || this.isNegotiator);
  }

  displayEditApplicantFields() {
    const buttonElt = document.activeElement as HTMLElement;
    buttonElt?.blur();
    this.editApplicantFieldsDialogRef = this.dialog.open(this.editApplicantFieldsDialog, {
      width: '900px'
    });
    this.initializeEditApplFields(this.data);
    this.noChangeMessage = '';
    this.applicantName = this.data.submittedBy ?? '';
    this.selectApplicantEdit = false;
    this.selectNewApplicant = false;
  }

  initializeEditApplFields(data: ApplicationData) {
    this.editApplicantFieldsForm = this.formBuilder.group({
      street1 : [ this.applicantAddress.street1, Validators.required],
      street2 : [ this.applicantAddress.street2],
      city : [ this.applicantAddress.city, Validators.required],
      state : [ this.applicantAddress.state, Validators.required],
      zipCode : [ this.applicantAddress.zipCode, Validators.required],
      country : [ this.applicantAddress.country, Validators.required],
      phone : [ data.phone, [Validators.required, Validators.pattern(fieldPatterns.telephoneNumber)]],
      phoneType : [ data.phoneType],
      contactPersonFirst : [ data.contactPersonFirstName, Validators.required],
      contactPersonLast : [ data.contactPersonLastName, Validators.required],
      pronoun : [ data.pronoun],
      title : [ data.title],
      emailAddress : [ data.emailAddress, [Validators.required,Validators.pattern(fieldPatterns.emailAddress)]],
      applicant : [data.submittedByUserObj, Validators.required]
    });
    this.selectingCountry(this.applicantAddress.country);
    this.initialFormValues = Object.assign({}, this.editApplicantFieldsForm.value);
  }

  selectingCountry(country: any) {
    if(country === 'USA') {
      this.displayStatesList = true;
    } else
      this.displayStatesList = false;
  }

  saveEditApplicantFields() {
    this.saveEditFields(this.editApplicantFieldsForm);
  }

  disableApplicantSaveBtn() {
    if(!this.editApplicantFieldsForm?.valid) 
      return true; 
    if(this.editApplicantFieldsForm?.untouched && this.editApplicantFieldsForm?.pristine) 
        return true; 
    return false; 
  }

  cancelEditApplicantFields(){
    this.selectApplicantEdit = false;
    this.selectNewApplicant = false;
    this.applicantName = this.data.submittedBy ?? '';
    this.editApplicantFieldsDialogRef.close();
  }

  selectPaymentDate(value: any) {
    if(value) {
      //let selData = value.toLocaleDateString('en-US', 
         // {timeZone: 'UTC',year: 'numeric',month: '2-digit',day: '2-digit'});
      this.paymentDateSelected = this.formatDateField(value);
    } 
  }

  formatDateField(value: any) {
    return value.toLocaleDateString('en-US', 
          {timeZone: 'UTC',year: 'numeric',month: '2-digit',day: '2-digit'});
  }

  disablePaymentDateEdit() {
    if(!this.paymentDateSelected)
      return true;
    return false;
  }

  retrieveFormattedDateForPicker( pDate: string) {
    if(pDate) {
      let paymentDate = new Date(pDate);
      paymentDate.setMinutes(paymentDate.getMinutes() + paymentDate.getTimezoneOffset());
      let rDate  = paymentDate.toISOString();
      return rDate;
    }
    return '';
  }

  disableFinalAdoptedNameEdit() {
    if(!this.selectedFinalAdoptedName)
      return true;
    return false;
  }

  disableFinalAdoptedNameModEdit() {
    if(!this.selectedFinalAdoptedNameMod)
      return true;
    return false;
  }

  selectAdoptedOrClosedDate(value: any) {
    if(value) 
      this.adoptedOrClosedDateSelected = this.formatDateField(value);
  }

  disableAdoptedOrClosedDate() {
    if(!this.adoptedOrClosedDateSelected)
      return true;
    return false;
  }

  openEditApplicantSelection() {
    this.selectApplicantEdit = true;
  }

  selectingApplicant(applicant: any) {
    this.selectedApplicant = applicant;
    this.editApplicantFieldsForm.get('applicant')?.setValue(applicant);
    this.editApplicantFieldsForm?.markAsTouched();
    this.selectNewApplicant = true;
  }

  retrieveUserData() {
    if(this.userEmail && this.userId) {
        this.adminService.getUsersForAdminDashboard(this.userEmail, this.userId).subscribe({
          next: res => {
            if (res.Errors.length > 0) {
              this.alertService.displayError("Error occurred while retrieving user data" + res.ErrorMessage);
            } else {  
              if(res.Data) {
                let results : UserData[] = [];
                res.Data.forEach(element => {
                  element.roles.forEach(role => {
                    let userType = this.parseUsanAccessType(role.roleName);
                    let userStatus = element.userStatus;
                    let companyName : string = element.companyName.trim();

                    if(userType === 'Applicant' && userStatus === 'Active' && companyName.trim() === this.companyName.trim()) {
                    let appRecord : UserData = {
                        userName: element.firstName + ' ' + element.lastName,
                        email: element.emailAddress,
                        uniqueId: element.ssoUniqueId,
                        firstName: element.firstName,
                        lastName: element.lastName
                      };
                    
                    results.push(appRecord);
                    }
                  });
                  
                });
                this.applicantsList = results;
                this.usersLoadingComplete = true;
              }
            }
          },
          error: error => {
            this.alertService.displayError("Error occurred while retrieving user data" + error.message);
            this.usersLoadingComplete = true;
          }  
        }); 
      } else {
        console.log('No email and uniqueId found for the user');
        this.usersLoadingComplete = true;
      }
  }

  disableUpdateCollabButton(uType: string) {
    if(uType === 'collab1') {
      if( !this.selectedCollaborator1)
        return true;
    } else if (uType === 'collab2') {
      if( !this.selectedCollaborator2)
        return true;
    }
    return false;
  }

  clickAction() {
    const model = UnlockCaseModel.parseValues(
      { caseSysId: this.adminService.getCurrentApplicationCaseSysId() }
    );

    this.formService.unlockCase(model).subscribe({
      next: () => this.adminService.clearCurrentApplicationCaseSysId(),
      error: (err) => {
        console.error(err);
        this.adminService.clearCurrentApplicationCaseSysId();
      }
    });
    this.router.navigate([this.sourcePath]);
  }

}

